import { Box, Text } from '@nimbus-ds/components';
import PromoteIcon from '../PromoteIcon';
import RecommendationIcon from '../RecommendationIcon';
import { TaskData, ContentType } from '../types';

interface TaskContentProps {
  data: TaskData;
  contentType: ContentType;
}

function TaskContent({ data, contentType }: TaskContentProps) {
  return (
    <Box display="flex" gap="3">
      {contentType === 'promote' && <PromoteIcon type={data.iconType} />}
      {contentType === 'recommendation' && (
        <RecommendationIcon type={data.iconType} />
      )}
      <Box display="flex" flexDirection="column" gap="none" alignSelf="center">
        <Text fontSize="caption" color="neutral-textHigh">
          {data.title}
        </Text>
        <Text fontSize="caption" color="neutral-textLow">
          {data.description}
        </Text>
      </Box>
    </Box>
  );
}

export default TaskContent;
